<script>
import {axios, swal} from '../../mixins';

export default {
  name: 'FileUpload',

  inheritAttrs: false,

  mixins: [axios, swal],

  props: {
    url: {
      required: true,
      type: String,
    },
    value: {
      required: false,
      type: String,
      default: '',
    },
  },

  data() {
    return {
      file: this.value,
    };
  },

  activated() {
    this.file = this.value;
  },

  watch: {
    value(newValue) {
      this.file = newValue;
    },
  },

  methods: {
    triggerUploadFileExplorer() {
      this.$refs.file.click();
    },
    doUpload(event) {
      let files = event.target.files;
      if (files.length != 1) {
        return;
      }

      let data = new FormData();
      data.append('_token', this.csrf());
      data.append('upload', event.target.files[0]);

      this.swalLoading('', 'Uploading file...');

      this.post(this.url, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        this.swalClose();
        this.swalSuccess('', `Successfully uploaded file`);

        this.$emit('getFiles')
      }).catch(() => {
        this.$refs.file.value = '';

        this.swalClose();
        this.swalError('', `Failed to upload file`);
      });
    },
  },
};
</script>

<template>
  <div class="flex flex-col">
    <div class="flex flex-row">
      <input class="hidden" type="file" ref="file" @change="doUpload">
      <button @click="triggerUploadFileExplorer" type="button" class="button button-wide text-white bg-green hover:bg-green-dark focus:bg-green-darker font-semibold">
        <span class="hidden sm:inline"><i class="fad fa-upload mr-1"></i> Upload</span>
      </button>
    </div>
  </div>
</template>
